import React from 'react'
import { getOrderUrl, trackOrderClick } from '../../utils/analytics';

export default function Hero({ scrollToSection }) {

  return (
    <section id="home" className="relative w-full h-screen flex items-center justify-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero.jpg"
          alt="RNY Coffee Studio interior"
          className="w-full h-full object-cover"
          width="919"
          height="1020"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Hero Content - Simpler & Bigger */}
      <div className="relative z-10 text-center px-6 max-w-4xl">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-6 tracking-tight font-serif">
          RNY Coffee Studio
        </h1>
        <p className="text-xl md:text-2xl text-white/90 font-light mb-12 font-serif">
          Roast with passion, yield with purpose
        </p>
        
        {/* Simpler Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href={getOrderUrl("hero")}
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 rounded-full bg-white text-black font-medium hover:bg-white/90 transition-all"
            onClick = {() => trackOrderClick("hero_order_now")}
          > 
            Order Now
          </a>
          <button 
            onClick={() => scrollToSection("location")}
            className="px-8 py-4 border-2 rounded-full border-white text-white font-medium hover:bg-white hover:text-black transition-all"
          >
            Visit Us
          </button>
        </div>
      </div>
    </section>
  )
}